export function packageSessionsAccountingCopy(pkg: {
  sessionsUsed?: number | null
  sessionsUpcoming?: number | null
  sessionsRemaining?: number | null
  numberOfSessions?: number | null
}): string {
  const total = pkg.numberOfSessions ?? 0
  const left = pkg.sessionsRemaining ?? 0
  const booked = total - left
  return `${booked} of ${total} booked`
}
